<template>
  <div>
    <div class="fields">
      <div class="eight wide required field">
        <label>店舗名</label>
        <input type="text" v-model="form.model.name">
        <validation-message :form="form" :field="'name'"></validation-message>
      </div>
      <div class="eight wide required field">
        <label>ヨミガナ</label>
        <input type="text" v-model="form.model.name_kana">
        <validation-message :form="form" :field="'name_kana'"></validation-message>
      </div>
    </div>
    <div class="fields">
      <div class="eight wide field">
        <label>店名修飾語</label>
        <input type="text" v-model="form.model.catchcopy">
        <validation-message :form="form" :field="'catchcopy'"></validation-message>
      </div>
      <div v-if="isAdministrator || userRole === 'shopadmin'" class="eight wide field">
        <label>店長名(予約責任者名)</label>
        <input type="text" v-model="form.model.manager_name">
        <validation-message :form="form" :field="'manager_name'"></validation-message>
      </div>
    </div>
    <basic-manage v-if="isAdministrator" :form="form"></basic-manage>
    <div v-if="isAdministrator || userRole === 'shopadmin'" class="fields">
      <div class="required eight wide field">
        <label>メールアドレス</label>
        <input type="text" v-model="form.model.email">
        <validation-message :form="form" :field="'email'"></validation-message>
      </div>
      <div class="eight wide field">
        <label>その他メールアドレス(カンマ区切りで複数指定可)</label>
        <input type="text" v-model="form.model.secondary_email">
        <validation-message :form="form" :field="'secondary_email'"></validation-message>
      </div>
    </div>
    <div class="fields" v-if="isAdministrator || userRole === 'afadmin'">
      <div class="required eight wide field">
        <label>都道府県</label>
        <dropdown id="prefecture" v-model="form.model.prefecture" :placeholder="'都道府県'">
          <option v-for="each in consts.SHOP_PREFECTURE" :key="each.label" :value="each.value" :disabled="each.value === ''">{{ each.label }}</option>
        </dropdown>
        <validation-message :form="form" :field="'prefecture'"></validation-message>
      </div>
      <div class="required eight wide field">
        <label>エリア</label>
        <dropdown v-model="form.model.area" @change="onAreaChange()" :placeholder="'エリア'">
          <option v-for="each in areaOptions" :key="each.label" :value="each.value" :disabled="each.value === ''">{{ each.label }}</option>
        </dropdown>
        <validation-message :form="form" :field="'area'"></validation-message>
      </div>
      <div class="required eight wide field">
        <label>エリア詳細</label>
        <dropdown ref="areaDetail" v-model="form.model.area_detail" :placeholder="'エリア詳細'">
          <option value="">エリア詳細</option>
        </dropdown>
        <validation-message :form="form" :field="'area_detail'"></validation-message>
      </div>
      <div class="required eight wide field">
        <label>最寄駅</label>
        <dropdown ref="station" v-model="form.model.station" @change="onStationChange()" :placeholder="'最寄駅'" key-prefix="station_"></dropdown>
        <validation-message :form="form" :field="'station'"></validation-message>
      </div>
    </div>
    <div class="field" v-if="isAdministrator || userRole === 'afadmin'">
      <label>その他の最寄駅(複数選択可能)</label>
      <dropdown ref="otherStation" v-model="form.model.other_stations" :max-size="-1" :placeholder="'その他の最寄駅'" key-prefix="other_stations_"></dropdown>
      <validation-message :form="form" :field="'other_stations'"></validation-message>
    </div>
    <div class="required field">
      <label>ジャンル(3つまで選択可能)</label>
      <dropdown v-model="form.model.genres" :options="consts.SHOP_GENRE" :max-size="3" :search="true" :placeholder="'ジャンル'"></dropdown>
      <validation-message :form="form" :field="'genres'"></validation-message>
    </div>
    <div class="field">
      <label>タグ</label>
      <dropdown v-model="form.model.tags" :max-size="-1" :search="true" :placeholder="'タグ'">
        <option v-for="tag in consts.SHOP_TAGS" :value="tag">{{ tag }}</option>
      </dropdown>
      <validation-message :form="form" :field="'tags'"></validation-message>
    </div>
    <div class="field">
      <label>利用シーン</label>
      <dropdown v-model="form.model.scenes" :max-size="-1" :search="true" :placeholder="'利用シーン'">
        <option v-for="scene in consts.SHOP_SCENES" :value="scene">{{ scene }}</option>
      </dropdown>
      <validation-message :form="form" :field="'scenes'"></validation-message>
    </div>
    <div class="field">
      <label>こだわり</label>
      <dropdown v-model="form.model.features" :max-size="-1" :search="true" :placeholder="'こだわり'">
        <option v-for="feature in consts.SHOP_FEATURES" :value="feature">{{ feature }}</option>
      </dropdown>
      <validation-message :form="form" :field="'features'"></validation-message>
    </div>
    <div class="fields">
      <div class="required eight wide field">
        <label>電話番号</label>
        <input type="text" v-model="form.model.tel">
        <span class="caption">半角数字のみ入力</span>
        <validation-message :form="form" :field="'tel'"></validation-message>
      </div>
      <div class="eight wide field">
        <label>FAX番号</label>
        <input type="text" v-model="form.model.fax">
        <span class="caption">半角数字のみ入力</span>
        <validation-message :form="form" :field="'fax'"></validation-message>
      </div>
    </div>
    <div v-if="isAdministrator" class="field">
      <label>Twilio電話番号</label>
      <input type="text" v-model="form.model.twilio_tel">
      <span class="caption">半角数字のみ入力</span>
      <validation-message :form="form" :field="'twilio_tel'"></validation-message>
    </div>
    <div v-if="isAdministrator || userRole === 'afadmin'" class="fields">
      <div class="eight field">
        <label>都道府県</label>
        <input type="text" :value="selectedPrefectureName" disabled>
      </div>
      <div class="eight field">
        <label>市区町村</label>
        <input type="text" v-model="form.model.city" placeholder="新宿区">
        <validation-message :form="form" :field="'city'"></validation-message>
      </div>
      <div class="eight wide field">
        <label>それ以降の住所</label>
        <input type="text" v-model="form.model.address_detail" placeholder="中町1-2-3">
        <validation-message :form="form" :field="'address_detail'"></validation-message>
      </div>
      <div class="eight wide field">
        <label>建物名・フロア</label>
        <input type="text" v-model="form.model.address2">
        <validation-message :form="form" :field="'address2'"></validation-message>
      </div>
    </div>
    <div class="fields">
      <div class="required eight wide field">
        <label>住所</label>
        <input type="text" v-model="form.model.address">
        <validation-message :form="form" :field="'address'"></validation-message>
      </div>
      <div v-if="!isAdministrator && userRole !== 'afadmin'" class="eight wide field">
        <label>建物名・フロア</label>
        <input type="text" v-model="form.model.address2">
        <validation-message :form="form" :field="'address2'"></validation-message>
      </div>
    </div>
    <div class="required field">
      <label>アクセス</label>
      <input type="text" v-model="form.model.access" placeholder="例：○○駅前徒歩5分">
      <validation-message :form="form" :field="'access'"></validation-message>
    </div>
    <div class="required field">
      <label>営業時間</label>
      <textarea rows="2" v-model="form.model.opening_hours" placeholder="例：月～木:11:00－22:00 (L.O 21:30) 土日祝 10:00～23:00 (L.O 22:30)"></textarea>
      <validation-message :form="form" :field="'opening_hours'"></validation-message>
    </div>
    <div class="required field">
      <label>定休日</label>
      <input type="text" v-model="form.model.holiday">
      <validation-message :form="form" :field="'holiday'"></validation-message>
    </div>
    <div class="field">
      <label>会場タイプ</label>
      <div class="fields">
        <div v-for="shopType in consts.SHOP_TYPE" :key="shopType.value" class="field">
          <div class="ui checkbox radio">
            <input type="radio" v-model="form.model.shop_type" name="shop_type" :value="shopType.value">
            <label>{{ shopType.label }}</label>
          </div>
        </div>
      </div>
      <validation-message :form="form" :field="'shop_type'"></validation-message>
    </div>
    <div class="fields">
      <div class="four wide field">
        <label>座席数</label>
        <div class="ui right labeled input">
          <input type="number" v-model="form.model.max_seat_count" placeholder="100">
          <label class="ui label">席</label>
        </div>
      </div>
      <div class="four wide field">
        <label>個室数(会場数) 20名以上</label>
        <div class="ui right labeled input">
          <input type="number" v-model="form.model.room_count" placeholder="100">
          <label class="ui label">室</label>
        </div>
      </div>
      <div class="four wide field">
        <label>最大着席人数</label>
        <div class="ui right labeled input">
          <input type="number" v-model="form.model.max_count" placeholder="100">
          <label class="ui label">人</label>
        </div>
      </div>
      <div class="four wide field">
        <label>最大立食人数</label>
        <div class="ui right labeled input">
          <input type="number" v-model="form.model.max_standing_count" placeholder="100">
          <label class="ui label">人</label>
        </div>
      </div>
    </div>
    <div class="field">
      <label>貸切</label>
      <div class="fields">
        <div class="field">
          <div class="ui checkbox radio">
            <input type="radio" name="can_reserve" v-model="form.model.can_reserve" value="true">
            <label>可</label>
          </div>
        </div>
        <div class="field">
          <div class="ui checkbox radio">
            <input type="radio" name="can_reserve" v-model="form.model.can_reserve" :value="false">
            <label>不可</label>
          </div>
        </div>
      </div>
    </div>
    <div class="grouped fields">
      <label>支払方法</label>
      <div class="field">
        <checkbox-group v-model="form.model.payment" :options="consts.PAYMENT"></checkbox-group>
      </div>
    </div>
    <div class="field">
      <label>クレジットカード</label>
      <dropdown v-model="form.model.credit_cards" :options="consts.CREDIT_CARD" :max-size="-1"></dropdown>
      <validation-message :form="form" :field="'credit_cards'"></validation-message>
    </div>
    <div class="required field">
      <label>店舗TOP 見出し</label>
      <textarea rows="4" v-model="form.model.title"></textarea>
      <span class="caption">{{ form.model.title | length }} / 200 文字</span>
      <validation-message :form="form" :field="'title'"></validation-message>
    </div>
    <div class="required fields">
      <div class="required four wide field">
        <label>店舗TOP 画像</label>
        <s3 v-model="form.model.main_image"></s3>
        <validation-message :form="form" :field="'main_image'"></validation-message>
      </div>
      <div class="five wide field">
        <label>店舗TOP PR文</label>
        <textarea rows="4" v-model="form.model.main_image_title"></textarea>
        <span class="caption">{{ form.model.main_image_title | length }} / 200 文字</span>
        <validation-message :form="form" :field="'main_image_title'"></validation-message>
      </div>
      <div class="required seven wide field">
        <label>店舗TOP 詳細文</label>
        <textarea rows="4" v-model="form.model.main_image_contents"></textarea>
        <span class="caption">{{ form.model.main_image_contents | length }} / 500 文字</span>
        <validation-message :form="form" :field="'main_image_contents'"></validation-message>
      </div>
    </div>
    <div class="fields">
      <div class="four wide field">
        <label>店舗TOP サブ画像</label>
        <s3 v-model="form.model.sub_image"></s3>
        <validation-message :form="form" :field="'sub_image'"></validation-message>
      </div>
      <div class="five wide field">
        <label>店舗TOP サブPR文</label>
        <textarea rows="4" v-model="form.model.sub_image_title"></textarea>
        <span class="caption">{{ form.model.sub_image_title | length }} / 200 文字</span>
        <validation-message :form="form" :field="'sub_image_title'"></validation-message>
      </div>
      <div class="seven wide field">
        <label>店舗TOP サブ詳細文</label>
        <textarea rows="4" v-model="form.model.sub_image_contents"></textarea>
        <span class="caption">{{ form.model.sub_image_contents | length }} / 500 文字</span>
        <validation-message :form="form" :field="'sub_image_contents'"></validation-message>
      </div>
    </div>
    <div class="fields">
      <div class="four wide field">
        <label>店舗TOP サブ画像2</label>
        <s3 v-model="form.model.sub_image2"></s3>
        <validation-message :form="form" :field="'sub_image2'"></validation-message>
      </div>
      <div class="five wide field">
        <label>店舗TOP サブPR文2</label>
        <textarea rows="4" v-model="form.model.sub_image_title2"></textarea>
        <span class="caption">{{ form.model.sub_image_title2 | length }} / 200 文字</span>
        <validation-message :form="form" :field="'sub_image_title2'"></validation-message>
      </div>
      <div class="seven wide field">
        <label>店舗TOP サブ詳細文2</label>
        <textarea rows="4" v-model="form.model.sub_image_contents2"></textarea>
        <span class="caption">{{ form.model.sub_image_contents2 | length }} / 500 文字</span>
        <validation-message :form="form" :field="'sub_image_contents2'"></validation-message>
      </div>
    </div>
    <div class="fields">
      <div class="eight wide field">
        <label>サブコンテンツ見出し1</label>
        <textarea rows="4" v-model="form.model.sub_heading_title1"></textarea>
        <span class="caption">{{ form.model.sub_heading_title1 | length }} / 200 文字</span>
        <validation-message :form="form" :field="'sub_heading_title1'"></validation-message>
      </div>
      <div class="eight wide field">
        <label>サブコンテンツ文章1</label>
        <textarea rows="4" v-model="form.model.sub_heading_contents1"></textarea>
        <span class="caption">{{ form.model.sub_heading_contents1 | length }} / 500 文字</span>
        <validation-message :form="form" :field="'sub_heading_contents1'"></validation-message>
      </div>
    </div>
    <div class="fields">
      <div class="eight wide field">
        <label>サブコンテンツ見出し2</label>
        <textarea rows="4" v-model="form.model.sub_heading_title2"></textarea>
        <span class="caption">{{ form.model.sub_heading_title2 | length }} / 200 文字</span>
        <validation-message :form="form" :field="'sub_heading_title2'"></validation-message>
      </div>
      <div class="eight wide field">
        <label>サブコンテンツ文章2</label>
        <textarea rows="4" v-model="form.model.sub_heading_contents2"></textarea>
        <span class="caption">{{ form.model.sub_heading_contents2 | length }} / 500 文字</span>
        <validation-message :form="form" :field="'sub_heading_contents2'"></validation-message>
      </div>
    </div>
    <div class="fields">
      <div class="eight wide field">
        <label>サブコンテンツ見出し3</label>
        <textarea rows="4" v-model="form.model.sub_heading_title3"></textarea>
        <span class="caption">{{ form.model.sub_heading_title3 | length }} / 200 文字</span>
        <validation-message :form="form" :field="'sub_heading_title3'"></validation-message>
      </div>
      <div class="eight wide field">
        <label>サブコンテンツ文章3</label>
        <textarea rows="4" v-model="form.model.sub_heading_contents3"></textarea>
        <span class="caption">{{ form.model.sub_heading_contents3 | length }} / 500 文字</span>
        <validation-message :form="form" :field="'sub_heading_contents3'"></validation-message>
      </div>
    </div>
    <div class="fields">
      <div class="eight wide field">
        <label>サブコンテンツ見出し4</label>
        <textarea rows="4" v-model="form.model.sub_heading_title4"></textarea>
        <span class="caption">{{ form.model.sub_heading_title4 | length }} / 200 文字</span>
        <validation-message :form="form" :field="'sub_heading_title4'"></validation-message>
      </div>
      <div class="eight wide field">
        <label>サブコンテンツ文章4</label>
        <textarea rows="4" v-model="form.model.sub_heading_contents4"></textarea>
        <span class="caption">{{ form.model.sub_heading_contents4 | length }} / 500 文字</span>
        <validation-message :form="form" :field="'sub_heading_contents4'"></validation-message>
      </div>
    </div>
    <div class="fields">
      <div class="eight wide field">
        <label>サブコンテンツ見出し5</label>
        <textarea rows="4" v-model="form.model.sub_heading_title5"></textarea>
        <span class="caption">{{ form.model.sub_heading_title5 | length }} / 200 文字</span>
        <validation-message :form="form" :field="'sub_heading_title5'"></validation-message>
      </div>
      <div class="eight wide field">
        <label>サブコンテンツ文章5</label>
        <textarea rows="4" v-model="form.model.sub_heading_contents5"></textarea>
        <span class="caption">{{ form.model.sub_heading_contents5 | length }} / 500 文字</span>
        <validation-message :form="form" :field="'sub_heading_contents5'"></validation-message>
      </div>
    </div>
    <div class="fields">
      <div class="eight wide field">
        <label>サブコンテンツ見出し6</label>
        <textarea rows="4" v-model="form.model.sub_heading_title6"></textarea>
        <span class="caption">{{ form.model.sub_heading_title6 | length }} / 200 文字</span>
        <validation-message :form="form" :field="'sub_heading_title6'"></validation-message>
      </div>
      <div class="eight wide field">
        <label>サブコンテンツ文章6</label>
        <textarea rows="4" v-model="form.model.sub_heading_contents6"></textarea>
        <span class="caption">{{ form.model.sub_heading_contents6 | length }} / 500 文字</span>
        <validation-message :form="form" :field="'sub_heading_contents6'"></validation-message>
      </div>
    </div>
    <div v-if="userRole === 'afadmin'" class="field">
      <label>店舗レイアウト画像</label>
      <s3 v-model="form.model.layout_image"></s3>
      <validation-message :form="form" :field="'layout_image'"></validation-message>
    </div>
    <div class="fields">
      <div class="four wide required field">
        <label>喫煙</label>
        <dropdown v-model="form.model.smoking_type" :placeholder="'喫煙'">
          <option v-for="each in consts.SMOKING" :key="each.value" :value="each.value" :disabled="each.value === ''">{{ each.label }}</option>
        </dropdown>
        <validation-message :form="form" :field="'smoking_type'"></validation-message>
      </div>
      <div class="ten wide field">
        <label>備考</label>
        <textarea v-model="form.model.smoking_remarks"></textarea>
        <validation-message :form="form" :field="'smoking_remarks'"></validation-message>
      </div>
    </div>
    <div class="field">
      <label>昼宴会</label>
      <div class="fields">
        <div class="field">
          <div class="ui checkbox radio">
            <input type="radio" v-model="form.model.lunch_ok" value="true" name="lunch_ok">
            <label>可</label>
          </div>
        </div>
        <div class="field">
          <div class="ui checkbox radio">
            <input type="radio" v-model="form.model.lunch_ok" value="false" name="lunch_ok">
            <label>不可</label>
          </div>
        </div>
      </div>
    </div>
    <div class="field">
      <label>持込み</label>
      <div class="fields">
        <div class="field">
          <div class="ui checkbox radio">
            <input type="radio" v-model="form.model.bringing_ok" value="true" name="bringing_ok">
            <label>可</label>
          </div>
        </div>
        <div class="field">
          <div class="ui checkbox radio">
            <input type="radio" v-model="form.model.bringing_ok" value="false" name="bringing_ok">
            <label>不可</label>
          </div>
        </div>
        <div class="ten wide field">
          <input type="text" placeholder="備考" v-model="form.model.bringing_note">
        </div>
      </div>
    </div>
    <div class="field">
      <label>店舗URL</label>
      <input type="text" v-model="form.model.shop_url">
      <validation-message :form="form" :field="'shop_url'"></validation-message>
    </div>
    <div class="field">
      <label>引用元URL</label>
      <input type="text" v-model="form.model.source_url">
      <span class="caption">非契約店舗のみ有効</span>
      <validation-message :form="form" :field="'source_url'"></validation-message>
    </div>
    <div class="field">
      <label>プランURL</label>
      <input type="text" v-model="form.model.plan_url">
      <span class="caption">非契約店舗のみ有効</span>
      <validation-message :form="form" :field="'plan_url'"></validation-message>
    </div>
    <div class="field">
      <label>360度ビューURL</label>
      <input type="text" v-model="form.model.street_view_url">
      <validation-message :form="form" :field="'street_view_url'"></validation-message>
    </div>
    <div class="field">
      <label>キャンセル規定</label>
      <textarea rows="3" v-model="form.model.cancellation_policy"></textarea>
    </div>
    <div class="field">
      <label>最低保証金額</label>
      <textarea rows="2" v-model="form.model.min_guarantee_amount"></textarea>
    </div>
    <div class="field">
      <label>立候補通知メールを受信する</label>
      <div class="fields">
        <div class="field">
          <div class="ui checkbox radio">
            <input type="radio" v-model="form.model.candidate_mail_required" value="true" name="candidate_mail_required">
            <label>受信する</label>
          </div>
        </div>
        <div class="field">
          <div class="ui checkbox radio">
            <input type="radio" v-model="form.model.candidate_mail_required" value="false" name="candidate_mail_required">
            <label>受信しない</label>
          </div>
        </div>
      </div>
    </div>
    <div class="field">
      <label>自動生成QAコンテンツ</label>
      <div class="fields">
        <div class="field">
          <div class="ui checkbox radio">
            <input type="radio" v-model="form.model.faq_required" value="true" name="faq_required">
            <label>表示する</label>
          </div>
        </div>
        <div class="field">
          <div class="ui checkbox radio">
            <input type="radio" v-model="form.model.faq_required" value="false" name="faq_required">
            <label>表示しない</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasicManage from './basicManage.vue';

export default {
    components: {
        BasicManage: BasicManage
    },
    props: {
        form: {
            required: true
        },
        isNew: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
            currentArea: null,
            areas: [],
            areaDetails: [],
            stations: [],
            areaOptions: [],
        };
    },
    mounted: function() {
        if (this.isNew) {
            this.initializeAreaSelection();
        } else {
          var unwatch = this.$watch('form.model.area', function() {
              if (this.form.model.area) {
                  this.currentArea = this.form.model.area;
                  unwatch();
                  this.initializeAreaSelection();
              }
          });
          let unwatchOtherStations = this.$watch('form.model.other_stations', function() {
              if (this.form.model.other_stations) {
                this.form.model.other_stations = this.form.model.other_stations.map(function(other_station) {
                    return other_station.station;
                });
                unwatchOtherStations();
              }
          });
        }
    },
    computed: {
        selectedPrefectureName() {
            const selectedPrefecture = this.form.model.prefecture;
            const prefecture = this.consts.SHOP_PREFECTURE.find(prefecture => prefecture.value === selectedPrefecture);
            return prefecture ? prefecture.label : '';
        }
    },
    methods: {
        onAreaChange: function(keepAreaDetail) {
            if (!keepAreaDetail && (this.currentArea || this.isNew)) {
                this.form.model.area_detail = null;
                this.form.model.station = null;
                this.form.model.other_stations = [];
            }
            this.$refs.areaDetail.setOptions(this.areaDetailsOf(this.form.model.area, this.areaDetails));
            this.$refs.station.setOptions(this.stationsOfArea(this.form.model.area, this.stations));
            this.$refs.otherStation.setOptions(this.stationsOfArea(this.form.model.area, this.stations));
        },
        onStationChange: function(keepOtherStation) {
            if (!keepOtherStation && (this.currentArea || this.isNew)) {
                this.form.model.other_stations = [];
            }
            let filteredStations = this.stationsOfArea(this.form.model.area, this.stations);
            filteredStations = filteredStations.filter(function (station) {
                return station.value !== this.form.model.station;
            }.bind(this));
            this.$refs.otherStation.setOptions(filteredStations);
        },
        onPrefectureChange() {
          const selectedPrefecture = this.form.model.prefecture;
          if (selectedPrefecture === '') {
              this.form.model.area = null;
              this.areaOptions = [];
          } else {
              this.areaOptions = this.areas.filter(area => area.prefecture === selectedPrefecture);
              if (this.areaOptions.length > 0) {
                  this.form.model.area = null;
              }
          }
        },
        initializeAreaSelection: function() {
            this.createForm().get('/api/areas/', function(response) {
                _.forEach(response.data, function(each) {
                    this.areas.push(each);
                }.bind(this));
                const selectedPrefecture = this.form.model.prefecture;
                this.areaOptions = this.areas.filter(area => area.prefecture === selectedPrefecture);
            });
            this.createForm().get('/api/area_details/', function(response) {
                _.forEach(response.data, function(each) {
                    this.areaDetails.push(each);
                }.bind(this));
                this.onAreaChange(true);
            });
            this.createForm().get('/api/stations/', function(response) {
                _.forEach(response.data, function(each) {
                    this.stations.push(each);
                }.bind(this));
                this.$refs.station.setOptions(this.stationsOfArea(this.form.model.area, this.stations));
                this.onStationChange(true);
            });
            this.$nextTick(() => {
                const inputPrefecture = this.$el.querySelector('#prefecture');
                if (inputPrefecture) {
                    inputPrefecture.addEventListener('change', this.onPrefectureChange);
                }
            });
        }
    }
};
</script>
